import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/BaseUrl"
import httpRequest from "../../utils/httpsRequest";

export const fetchFood = createAsyncThunk(
  "food/fetchFood",
  async (arg) => {
    return httpRequest(`${BASE_URL}/Foods?CategoryId=${arg.categoryId}&SearchText=${arg.searchText}&PageSize=${arg.pageSize}&PageNumber=${arg.pageNumber}`);
  }
)

const foodSlice = createSlice({
  name: 'food',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchFood.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchFood.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchFood.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});
export default foodSlice.reducer;

